import React, { useEffect } from "react";
import StudentSignup from "../StudentSignUp/StudentSignup";
import PropTypes from "prop-types";

const MentorSignUp = (props) => {
  const { title } = props;

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <StudentSignup />
  );
};

MentorSignUp.propTypes = {
  title: PropTypes.string.isRequired,
};

export default MentorSignUp;
